export enum CrmSegment {
  Cancelled = 'CANCELLED',
  ExclusiveBuyers = 'EXCLUSIVE_BUYERS',
  Leads = 'LEADS',
  Subscribed = 'SUBSCRIBED',
}
